var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0736 0.666504H3.07357C2.3369 0.666504 1.74023 1.26317 1.74023 1.99984V11.3332H3.07357V1.99984H11.0736V0.666504ZM13.0736 3.33317H5.74023C5.00357 3.33317 4.4069 3.92984 4.4069 4.6665V13.9998C4.4069 14.7365 5.00357 15.3332 5.74023 15.3332H13.0736C13.8102 15.3332 14.4069 14.7365 14.4069 13.9998V4.6665C14.4069 3.92984 13.8102 3.33317 13.0736 3.33317ZM13.0736 13.9998H5.74023V4.6665H13.0736V13.9998Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.ca52fc0df3a9c92ca571405d3271e74d.svg";
export { ForwardRef as ReactComponent };